import { render, staticRenderFns } from "./UserForgot.vue?vue&type=template&id=7b32f7ca&"
import script from "./UserForgot.vue?vue&type=script&lang=js&"
export * from "./UserForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports